import { RootState } from '@reducers';

export const selectOtpLink = (state: RootState) => state.userDashboardRouteReducer.otpLinkReducer;
